<div class="">
    <mat-toolbar class="justify-content-center" color="primary">
        <div class="mat-headline">
            Customer Profile Setup
        </div>
    </mat-toolbar>
    <form [formGroup]="customerProfileSetup.customerProfileSetupForm" (submit)="onSubmit()">
        <mat-grid-list cols="2">
            <mat-grid-tile>
                <div class="adminControls">
                    <!-- <input type="hidden" formControlName="_id"> -->
                    <mat-form-field appearance="outline">
                        <mat-label>ID: </mat-label>
                        <input matInput formControlName="id">
                        <!-- <mat-error>This feild is required</mat-error> -->
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label> Name: </mat-label>
                        <input matInput formControlName="name" required>
                        <mat-error
                            *ngIf="customerProfileSetup.customerProfileSetupForm.controls['name'].errors?.required">This
                            feild is required</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Street: </mat-label>
                        <input matInput formControlName="street" required>
                        <mat-error
                            *ngIf="customerProfileSetup.customerProfileSetupForm.controls['street'].errors?.required">
                            This feild is required</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" color="primary">
                        <mat-label>City:</mat-label>
                        <mat-select formControlName="city">
                            <mat-option>None</mat-option>
                            <ng-container *ngFor="let x of cities">
                                <mat-option value="{{x.code}}">{{x.name}}</mat-option>
                            </ng-container>
                        </mat-select>
                        <mat-error
                            *ngIf="customerProfileSetup.customerProfileSetupForm.controls['city'].errors?.required">
                            Please select feild</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" color="primary">
                        <mat-label>State:</mat-label>
                        <mat-select formControlName="state">
                            <mat-option>None</mat-option>
                            <ng-container *ngFor="let x of states">
                                <mat-option value="{{x.code}}">{{x.name}}</mat-option>
                            </ng-container>
                        </mat-select>
                        <mat-error>This feild is required</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Zipcode: </mat-label>
                        <input matInput formControlName="zipcode" required>
                        <mat-error>This feild is required</mat-error>
                    </mat-form-field>
                </div>
            </mat-grid-tile>
            <mat-grid-tile>
                <div class="adminControls">
                    <mat-form-field appearance="outline">
                        <mat-label> Contact Name: </mat-label>
                        <input matInput formControlName="contactName" required>
                        <mat-error>This feild is required</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Phone1: </mat-label>
                        <input matInput formControlName="phone1" required>
                        <mat-error
                            *ngIf="customerProfileSetup.customerProfileSetupForm.controls['phone1'].errors?.required">
                            This feild is required</mat-error>
                        <mat-error
                            *ngIf="customerProfileSetup.customerProfileSetupForm.controls['phone1'].errors?.minlength">
                            Min Length is 10 Digits</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Phone2: </mat-label>
                        <input matInput formControlName="phone2" required>
                    </mat-form-field>
                    <div class="myPadding">
                        <mat-radio-group formControlName="gender" color="primary">
                            <mat-radio-button value="1">Male</mat-radio-button>
                            <mat-radio-button value="2">Female</mat-radio-button>
                            <mat-radio-button value="3">Others</mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <mat-form-field appearance="outline">
                        <mat-label>Fax: </mat-label>
                        <input matInput formControlName="fax" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Email: </mat-label>
                        <input matInput formControlName="email" required>
                        <mat-error
                            *ngIf="customerProfileSetup.customerProfileSetupForm.controls['email'].errors?.required">
                            This feild is required</mat-error>
                        <mat-error
                            *ngIf="customerProfileSetup.customerProfileSetupForm.controls['email'].errors?.email">Enter
                            valid email format</mat-error>
                    </mat-form-field>
                    <div class="buttonRow">
                        <button [disabled]="customerProfileSetup.customerProfileSetupForm.invalid" mat-raised-button
                            color="primary" type="submit">Register</button>
                        <button mat-raised-button color="warn" type="button" (click)="this.customerProfileSetup.onClear()">Reset</button>
                    </div>
                </div>
            </mat-grid-tile>
        </mat-grid-list>
    </form>
</div>